export class UserInfoRole {
  roleId!: number;
  roleName!: string;
}
